import { useMemo } from "react";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { useFetchCategoryStatusCompanies } from "@lhd/hooks";
import { APP_TYPES } from "../../../constants";

interface UseBusinessTripReportsChooseProps {
  appType?: string;
  item: AppPartType;
}

export const useBusinessTripReportsChoose = ({
  appType,
  item,
}: UseBusinessTripReportsChooseProps) => {
  const isDisableFieldOfBusinessTripReports =
    appType === APP_TYPES.BUSINESS_TRIP_REPORTS &&
    (item.field_code === "ステータス" ||
      item?.field_code === "status" ||
      item?.field_code === "application_creator" ||
      item?.field_code === "application_approver" ||
      item?.field_code === "application_date" ||
      item?.field_code === "approval_date");

  const isCategoryFieldOfBusinessTripReports =
    appType === APP_TYPES.BUSINESS_TRIP_REPORTS &&
    (item.field_code === "カテゴリー" || item.field_code === "category");

  const { data: categoryStatusCompaniesData, isLoading: isCategoryLoading } =
    useFetchCategoryStatusCompanies(
      { screen: "business_trip_reports" },
      isCategoryFieldOfBusinessTripReports,
    );

  const statusOptions = useMemo(
    () => [
      { value: "drafting", label: "新規作成中" },
      { value: "submitted", label: "新規申請済（承認待）" },
      { value: "reviewing", label: "申請受付済（確認中）" },
      { value: "approved", label: "承認済（給与明細反映）" },
      { value: "rejected", label: "却下" },
    ],
    [],
  );

  const dynamicCategoryOptions = useMemo(() => {
    if (!categoryStatusCompaniesData?.data) return [];
    return categoryStatusCompaniesData.data
      .filter((i: any) => i.record_type === "category")
      .map((i: any) => ({
        value: i.name,
        label: i.name,
      }));
  }, [categoryStatusCompaniesData]);

  return {
    isDisableFieldOfBusinessTripReports,
    isCategoryFieldOfBusinessTripReports,
    statusOptions,
    dynamicCategoryOptions,
    isCategoryLoading,
  };
};
